<form>
    <app-form-section [formGroup]="detailsForm">
        <app-form-row-header [title]="agreementTypeName" icon="contract" />
        <div class="form">
            <app-form-row>
                <app-form-group>
                    <label for="agreementNo">
                        {{ 'FEATURES.AGREEMENTS.AGREEMENTNO' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.AgreementNumber" />
                    </label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="agreementNo"
                        formControlName="agreementNo"
                        type="text"
                        [placeholder]="'FEATURES.AGREEMENTS.PLACEHOLDERS.AGREEMENTNO' | translate"
                        [ngClass]="{
                            'highlight-animated': isFieldHighlighted(agreementMetaDataConstants.AgreementNumber)
                        }"
                        (focus)="onFieldFocus(agreementMetaDataConstants.AgreementNumber)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.agreementNo"
                        languageKey="FEATURES.AGREEMENTS.AGREEMENTNO"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="name">
                        {{ 'FEATURES.AGREEMENTS.NAME' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.Name" />
                    </label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="name"
                        formControlName="name"
                        type="text"
                        [ngClass]="{
                            'highlight-animated': isFieldHighlighted(agreementMetaDataConstants.Name)
                        }"
                        (focus)="onFieldFocus(agreementMetaDataConstants.Name)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.name"
                        languageKey="FEATURES.AGREEMENTS.NAME"
                    />
                </app-form-group>
            </app-form-row>

            <app-form-row>
                <app-form-group>
                    <label for="area"
                        >{{ 'FEATURES.AGREEMENTS.AREA' | translate }}
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.AREA' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.Area" />
                    </label>
                    <app-listtype-select
                        formControlName="area"
                        listType="AREA"
                        [showPotentialValidationMessages]="true"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.Area)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.Area)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.area"
                        languageKey="FEATURES.AGREEMENTS.AREA"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="category"
                        >{{ 'FEATURES.AGREEMENTS.CATEGORY' | translate }}
                        <span
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.CATEGORY' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.Category" />
                    </label>
                    <app-listtype-select
                        formControlName="category"
                        listType="CATEGORY"
                        [showPotentialValidationMessages]="true"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.Category)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.Category)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.category"
                        languageKey="FEATURES.AGREEMENTS.CATEGORY"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row>
                <app-form-group>
                    <label for="description">
                        {{ 'FEATURES.AGREEMENTS.DESCRIPTION' | translate }}
                    </label>
                    <textarea
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        formControlName="description"
                        [placeholder]="'FEATURES.AGREEMENTS.PLACEHOLDERS.DESCRIPTION' | translate"
                        [ngClass]="{
                            'highlight-animated': isFieldHighlighted(agreementMetaDataConstants.Description)
                        }"
                        (focus)="onFieldFocus(agreementMetaDataConstants.Description)"
                    ></textarea>
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
